import React, { FunctionComponent } from 'react'

import { FingerprintBiometricsPromptIconProps } from './FingerprintBiometricsPromptIconSvg'
import { withSuspense } from '../../utils/withSuspense'

const FingerprintBiometricsPromptIconSvg = withSuspense({
  component: React.lazy(() => import('./FingerprintBiometricsPromptIconSvg')),
})

export const FingerprintBiometricsPromptIcon: FunctionComponent<FingerprintBiometricsPromptIconProps> = ({
  width,
  height,
}) => {
  return <FingerprintBiometricsPromptIconSvg width={width} height={height} />
}
